<template>
  <div class="sticky top-0 w-96 flex flex-col h-full overflow-hidden">
    <div
      class="px-4 py-3 text-slate-900 font-semibold flex items-center justify-between text-lg"
    >
      <span>Sources</span>
      <Modal ref="addCustomSource" :show-footer="false">
        <template #activator="{ show }">
          <PlanLockGuard>
            <button
              class="flex items-center gap-1 text-sm text-blue-600 font-medium hover:text-blue-700"
              :disabled="!isPlanEditable"
              @click="show"
            >
              <PlusIcon class="w-4 h-4" />
              <span>Add Source</span>
            </button>
          </PlanLockGuard>
        </template>
        <template #header="{ hide }">
          <div class="flex gap-1 items-center">
            <DatabaseSolideIcon class="text-blue-800 w-5 h-5" />
            <div class="text-blue-800 font-semibold text-base">
              Custom source / Hand search
            </div>
          </div>
          <div class="flex justify-end">
            <button class="p-2" @click="hide">
              <XMarkIcon class="w-6 text-slate-400 hover:text-slate-600" />
            </button>
          </div>
        </template>
        <template #content="{ hide }">
          <CustomSourceHandSearch :readonly="isPlanEditable" @hide="hide" />
        </template>
      </Modal>
    </div>
    <hr />
    <div class="overflow-y-auto">
      <div class="divide-y">
        <SourcesPanel
          v-for="type in sourceTypes"
          :key="type"
          :source-type="type"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewKey } from '../../../use-review'
import SourcesPanel from './SourcesPanel.vue'
import Modal from '@app/components/Global/Modal/Modal.vue'
import CustomSourceHandSearch from '../Components/CustomSourceHandSearch.vue'
import { PlusIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'
import DatabaseSolideIcon from '@app/components/Icons/DatabaseSolideIcon.vue'
import PlanLockGuard from '../../PlanLockGuard.vue'

const sourceTypes = [
  'Peer-reviewed literature',
  'Gray literature',
  'Systematic reviews',
  'Clinical trials',
  'Safety: Incidents',
  'Safety: FSNs, FSCAs, bans, recalls, etc...',
  'Health technology assessments',
  //'Standards',
  //'Guidance',
]
const review = injectStrict(ReviewKey)

const isPlanEditable = computed(() => !review.isPlanReadonly.value)
</script>

<style scoped>
.tree {
  position: relative;
  padding-left: 20px;
}

.item {
  position: relative;
}

.sub-item {
  position: relative;
}

.sub-item::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: rgb(60 60 60 / 0.3);
}

.sub-item span::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  width: 20px;
  height: 1px;
  background-color: rgb(60 60 60 / 0.3);
}

.sub-item:last-child::before {
  height: 50%;
}
</style>
